/**
 * Central route path constants. Use these (and the builders for dynamic
 * segments) instead of hard-coded string literals in router config and
 * navigate() calls.
 */
export const ROUTES = {
  LOGIN: "/",
  HOME: "/home",
  PROJECT: (id: string) => `/home/${id}`,
  DASHBOARD: (projectId: string, name: string, mode?: "view") =>
    `/dashboards/${encodeURIComponent(projectId)}/${encodeURIComponent(name)}${mode === "view" ? "?mode=view" : ""}`,
  TAB_SPEC: (projectId: string, name: string) =>
    `/tables/${encodeURIComponent(projectId)}/${encodeURIComponent(name)}`,
  AUTOMATION: "/automation",
  DOCS: "/docs",
  DOCS_PAGE: (section: string, page: string) => `/docs/${section}/${page}`,
  SUPERADMIN: "/superadmin",
} as const

/** Router path patterns (with param placeholders). */
export const ROUTE_PATTERNS = {
  LOGIN: "/",
  HOME: "/home",
  PROJECT: "/home/:id",
  DASHBOARD: "/dashboards/:projectId/:name",
  TAB_SPEC: "/tables/:projectId/:name",
  AUTOMATION: "/automation",
  DOCS: "/docs/:section?/:page?",
  SUPERADMIN: "/superadmin",
} as const
